import { render } from "./PageLoading.vue?vue&type=template&id=38100a2e&ts=true"
import script from "./PageLoading.vue?vue&type=script&lang=ts"
export * from "./PageLoading.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__